import * as React from 'react'
import {
  List,
  ListProps,
  Datagrid,
  TextField,
  FunctionField,
  Record,
} from 'react-admin'
import PayoutStatusChip from '../../../components/chips/PayoutStatusChip'
import { DefaultPagination } from '../../../components/Pagination'
import { valueInCentsToBRL } from '../../../utils/utils'
import PayoutPerClinicActions from './PayoutPerClinicActions'
import PayoutPerClinicFilter from './PayoutPerClinicFilter'

const PayoutPerClinicList = ({ ...props }: ListProps) => {
  return (
    <List
      pagination={<DefaultPagination />}
      actions={<PayoutPerClinicActions />}
      filters={<PayoutPerClinicFilter />}
      bulkActionButtons={false}
      sort={{ field: 'clinic.name', order: 'ASC' }}
      {...props}
    >
      <Datagrid stickyHeader>
        <FunctionField
          textAlign="center"
          render={(record: Record | undefined) =>
            valueInCentsToBRL(record?.totalPayoutValueInCents)
          }
          label="Valor"
          source="totalPayoutValueInCents"
          sortable={false}
        />
        <TextField
          textAlign="center"
          sortable={false}
          source="clinic.name"
          label="Clínica"
        />
        <FunctionField
          textAlign="center"
          render={(record: Record | undefined) => (
            <PayoutStatusChip status={record?.status} />
          )}
          label="Status"
          source="status"
          sortable={false}
        />
      </Datagrid>
    </List>
  )
}

export default PayoutPerClinicList
